import type {
	CustomItem,
	DropProductCardGridType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropProductCardGrid = (
	item: Item | CustomItem
): item is DropProductCardGridType => {
	return !!(item && item.__typename === 'Drop_Product_Card_Grid');
};
